import React, { useState, useEffect } from 'react';

function RejectionReasonDialog({ isOpen, onClose, onSubmit, rowCount }) {
  const [reason, setReason] = useState('');
  const [validationError, setValidationError] = useState('');

  useEffect(() => {
    if (isOpen) {
      setReason('');
      setValidationError('');
    }
  }, [isOpen]);

  const handleSubmit = () => {
    if (!reason.trim()) {
      setValidationError('A rejection reason is required.');
      return;
    }
    onSubmit(reason.trim());
  };

  if (!isOpen) return null;

  return (
    <div className="export-dialog-overlay" onClick={onClose} role="dialog" aria-modal="true" aria-label="Reject Rows">
      <div className="export-dialog" onClick={e => e.stopPropagation()} style={{ maxWidth: 480 }}>
        <div className="export-dialog-header">
          <h3>Reject {rowCount} Row{rowCount !== 1 ? 's' : ''}</h3>
          <button className="export-dialog-close" onClick={onClose} aria-label="Close">&times;</button>
        </div>

        <div className="export-dialog-config">
          <div className="export-dialog-field">
            <label htmlFor="rejection-reason">Rejection Reason</label>
            <textarea
              id="rejection-reason"
              className="input"
              value={reason}
              onChange={e => { setReason(e.target.value); setValidationError(''); }}
              placeholder="Enter reason for rejection"
              rows={3}
              style={{ width: '100%', resize: 'vertical' }}
            />
            {validationError && (
              <div className="error-message" role="alert" style={{ marginTop: 4 }}>
                {validationError}
              </div>
            )}
          </div>
        </div>

        <div className="export-dialog-footer">
          <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary" onClick={handleSubmit}>Submit</button>
        </div>
      </div>
    </div>
  );
}

export default RejectionReasonDialog;
